import { useState } from "react";
import { useNavigate } from 'react-router-dom';
import '../css/landing.css';
import main from '../assets/LandImg.png';


export default function Landing() {
    const navigate = useNavigate();
    const [showModal, setShowModal] = useState(false);

    return(
        <div className="landing">
                <span className="left">
                    <div className="caption1">
                        <hr />
                        <h4>WE ARE TEAM NHRF</h4>
                    </div>
                    <div className="titles">
                        <div className="caption2">
                            <p>At <span>NHRF,</span> we work towards the betterment of our <span>world</span> </p>
                        </div>
                        <div className="caption3">
                            <p>Bring out the change in society by spreading hands to help the unprivileged children and other backward communities.</p>
                        </div>
                        <div className="btns">
                            <button
                             onClick={() => navigate("/about")} 
                             type="button" className="btn btn-outline-info">Know More</button>
                            <button type="button" className="btn btn-success" onClick={() => setShowModal(true)}>DONATE</button>
                        </div>
                    </div>

                </span>
                <span className="right">
                    <img src={main} alt="Smiling Faces" />
                </span>
                {showModal && (
                <div className="modal-overlay">
                    <div className="modal-content">
                        <h2>Support Our Cause</h2>
                        <p className="modal-subtitle">Your contribution makes a difference.</p>

                        <p>Bank Account Details:</p>
                        <ul>
                            <li><strong>Bank Name:</strong> Bank of India</li>
                            <li><strong>Branch Name:</strong> Beleghata Branch</li>    
                            <li><strong>Account Name:</strong>National Human Rights Federation</li>
                            <li><strong>Account Number:</strong> 402220110000430</li>
                            <li><strong>IFSC Code:</strong> BKID0004022</li>
                        </ul>
                      
                        <button className="btn btn-danger" onClick={() => setShowModal(false)}>Close</button>
                    </div>
                </div>
            )}

            </div>
    );
}